/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CarbonBlackGlobalSecretSpec { 
    cb_pop_id: string;
    org_key: string;
    username: string;
    password: string;
}

